var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "customer-container" },
    [
      _c("b-container", { attrs: { fluid: "" } }, [
        _c(
          "div",
          { staticClass: "main-content" },
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { staticClass: "text-center", attrs: { md: "3" } },
                  [
                    _c(
                      "div",
                      { staticClass: "avatar" },
                      [_c("Avatar", { attrs: { avatar: _vm.avatar } })],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { md: "5" } },
                  [
                    _c("h2", [
                      _vm._v(
                        _vm._s(
                          _vm.invalid ? "Login" : "Hallo " + _vm.firstName + "!"
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _vm.invalid
                      ? _c(
                          "div",
                          [
                            _c("p", [
                              _vm._v(
                                "Offensichtlich wurde der Link schon verwendet, um deine Erst-Anmeldung abzuschließen."
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", [_vm._v("Melde dich bitte an:")]),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  { attrs: { md: "6" } },
                                  [_c("Login")],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : [
                          _c("p", [
                            _vm._v(
                              "\n\t\t\t\t\t\t\tHier kannst du dir ein Passwort für skilldoo setzen.\n\t\t\t\t\t\t"
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "tag-sections" }, [
                            _c(
                              "section",
                              { staticClass: "tag" },
                              [
                                _c("h2", [_vm._v("Dein Passwort")]),
                                _vm._v(" "),
                                _c("Password", {
                                  model: {
                                    value: _vm.password,
                                    callback: function($$v) {
                                      _vm.password = $$v
                                    },
                                    expression: "password"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "section",
                              { staticClass: "tag" },
                              [
                                _c("PrivacyCheckbox", {
                                  model: {
                                    value: _vm.privacy,
                                    callback: function($$v) {
                                      _vm.privacy = $$v
                                    },
                                    expression: "privacy"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "section",
                              { staticClass: "tag" },
                              [
                                _c("Button", {
                                  attrs: {
                                    text: "Passwort speichern",
                                    icon: "checkmark",
                                    disabled: !_vm.dataValid || _vm.confirming,
                                    loading: _vm.confirming
                                  },
                                  on: { click: _vm.confirm }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c("Features", { staticClass: "mt-5" })
                        ]
                  ],
                  2
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }